import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { motion } from "framer-motion";
import { fetchSubscriptionPlans } from "../features/admin/slice/subcriptionSlice";
import PlanCard from "./PlanCard";
import axiosInstance from "../config/axios.config";

const Plans = () => {
  const dispatch = useDispatch();
  const { plans, loading, error } = useSelector((state) => state.subscriptions);
  const { user, token } = useSelector((state) => state.auth);
  const [userSubscriptions, setUserSubscriptions] = useState([]);

  
  const isAuthenticated = !!token;

  const dataFetchedRef = useRef(false);

  useEffect(() => {
    if (plans.length === 0 && !dataFetchedRef.current) {
      dispatch(fetchSubscriptionPlans());
      dataFetchedRef.current = true;
    }

   
    if (isAuthenticated && user?.id) {
      fetchUserPlans();
    }
  }, [dispatch, plans.length, isAuthenticated, user?.id]);

  const fetchUserPlans = async () => {
    try {
      const res = await axiosInstance.get(`subscriptions/users/${user.id}`);
      setUserSubscriptions(res.data);
    } catch (error) {
      console.error(error);
    }
  };

 

  const textVariants = {
    initial: {
      opacity: 0,
      y: 20,
    },
    animate: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };

  return (
    <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-0">
      <div className="flex flex-col justify-center items-center max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12 lg:py-16">
        <motion.h2
          variants={textVariants}
          initial="initial"
          animate="animate"
          className="text-3xl sm:text-4xl lg:text-5xl font-bold text-center mb-4 sm:mb-6"
        >
          Choose <span className="text-[#1B3673]">Your</span>{" "}
          <span className="text-[#F5A404]">Plan</span>
        </motion.h2>
        <p className="text-base sm:text-lg lg:text-xl text-gray-600 text-center mb-8 sm:mb-10 lg:mb-12 max-w-xl sm:max-w-2xl px-4">
          Whether you're just starting out or already have experience, Mentorhub
          offers flexible plans to fit your needs and ambitions. Upgrade anytime
          for deeper mentorship and specialized tools.
        </p>
      </div>

      {loading ? (
        <div className="flex justify-center items-center py-12">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#1B3673]"></div>
        </div>
      ) : error ? (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-6">
          <span className="block sm:inline">
            Failed to load subscription plans. Please try again later.
          </span>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {plans.map((plan, index) => (
            <PlanCard
              key={plan.id}
              plan={plan}
              index={index}
              isLoggedIn={isAuthenticated}
              userSubscriptions={userSubscriptions} 
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default Plans;
